import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import SiteRoot from '../app/SiteRoot';
import AdminRoot from "../admin/AdminRoot";
import {AdminBaseUrl} from "../admin/config/AdminConfig";
import {extractBaseUrlSegment} from "../common/fusion-ui/utils/ReactUtils";


import "font-awesome/css/font-awesome.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "../common/fusion-ui/css/fusion_css.css";
import "../common/assets/css/style.css";
// import '../common/assets/css/ThemeStyles_Orchid.css';


export default function ProjectRoot() {
    const browserUrl = (extractBaseUrlSegment(window.location.href) + '').toLowerCase();
    // const browserUrl = ((window.location.href + '').split('?')[0] + '').toLowerCase();//Get browser-url without params
    const isAdminPath = browserUrl.includes(AdminBaseUrl);
    console.log('ProjectRoot.browserUrl:', browserUrl, ', isAdminPath:', isAdminPath);
    return (
        <BrowserRouter>
            {isAdminPath
                ? <AdminRoot/>
                : <SiteRoot/>}
        </BrowserRouter>
    );
};
